// removed by extract-text-webpack-plugin
module.exports = {"selector":"_3JZgJtZWX vUrsJl1Yt"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/setupform-form/field/event-type-selector/event-type-selector-container.css
 ** module id = 2159
 ** module chunks = 0
 **/